import React from "react";
import "./CardSkeleton.css"; // reuses the .cd-skl shimmer keyframes

/*
  Skeleton primitive shared by the page-specific skeletons.

  The generic `<Skeleton>` variant library (generic/table/cards/form/dashboard)
  and its `Skeleton.css` layout were removed when the standard/default skeletons
  were taken out of the app. Only this `SkeletonBar` atom remains — it is what
  the page-specific skeletons (PavCardSkeleton, AocCardSkeleton, ReportsSkeleton,
  InfoSkeletons, GoalsSkeleton, InsuranceSkeleton, …) build on.
*/

/** Single shimmer block — the atom every page skeleton is built from. */
export const SkeletonBar = ({
  w = "100%",
  h = 12,
  r = 6,
  style,
}: {
  w?: number | string;
  h?: number | string;
  r?: number;
  style?: React.CSSProperties;
}) => (
  <span className="cd-skl" style={{ display: "block", width: w, height: h, borderRadius: r, ...style }} />
);

export default SkeletonBar;
